import './App.css';

import { Navbar, Homevideo, Quemsomos, Tecnologias, GeramosResultados } from './components'
import QuemConfia from './components/quemconfia/QuemConfia';
import { Footer } from './containers'
import Portfolio from './containers/portfolio/Portfolio';

const App = () => {
  return (
    <div className="App">
      <div className="lsk__main">
            <Navbar />
            <Homevideo />
            <Portfolio /> 
            <Quemsomos />
            <Tecnologias />
            <GeramosResultados />
            <QuemConfia />
            <Footer />
      </div>
    </div>
  );
}

export default App;
